import { SessionModel } from "../../../../../models/shared/session.model";

export abstract class IAdminSessionService {
  public abstract getActiveSession(): SessionModel;
}
